module.exports = __webpack_public_path__ + "assets/images/survey-modal.svg";